export class UserProfile {

    public username: string = '';
    public thumbnailUrl: string = '';
    public email: string = '';
  
    constructor() {
      
    }
}